import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "9.35"
    }, null, -1),
    _createElementVNode("path", { d: "M17.35 12c0 2.664-.65 5.044-1.665 6.737C14.662 20.442 13.34 21.35 12 21.35s-2.662-.908-3.685-2.613C7.299 17.044 6.65 14.664 6.65 12s.65-5.044 1.665-6.737C9.338 3.558 10.66 2.65 12 2.65s2.662.908 3.685 2.613C16.701 6.956 17.35 9.336 17.35 12M3 12h18M12 3v18" }, null, -1)
  ])))
}
export default { render: render }